import { DEFAULT_SORT_ATTRIBUTE, SORT_ORDER } from '../constants'

/**
 * Class representing a manager for the selected sorting attribute.
 * @see {@link https://github.com/aws-samples/aws-kendra-transcribe-media-search/blob/main/finderapp/src/search/sorting/SelectedSortingAttributeManager.ts SelectedSortingAttributeManager.ts}
 */
export class SelectedSortingAttributeManager {
  /**
   * Creates an instance of SelectedSortingAttributeManager.
   * @param {string} sortingAttribute - The sorting attribute.
   * @param {string|null} sortingOrder - The sorting order.
   */
  constructor(
    sortingAttribute,
    sortingOrder
  ) {
    this.sortingAttribute = sortingAttribute
    this.sortingOrder = sortingOrder
  }

  /**
   * Creates a default instance of SelectedSortingAttributeManager.
   * @returns {SelectedSortingAttributeManager} An instance with the default sorting attribute and no sorting order.
   */
  static default() {
    return new SelectedSortingAttributeManager(DEFAULT_SORT_ATTRIBUTE, null);
  }

  /**
   * Gets the selected sorting attribute.
   * @returns {string} The selected sorting attribute.
   */
  getSelectedSortingAttribute() {
    return this.sortingAttribute;
  }

  /**
   * Gets the selected sorting order.
   * @returns {string|null} The selected sorting order.
   */
  getSelectedSortingOrder() {
    return this.sortingOrder
  }

  /**
   * Sets the selected sorting attribute.
   * @param {string} sortingAttribute - The new sorting attribute.
   * @returns {SelectedSortingAttributeManager} A new instance with the updated sorting attribute and default sorting order if applicable.
   */
  setSelectedSortingAttribute(
    sortingAttribute
  ) {
    if (sortingAttribute === DEFAULT_SORT_ATTRIBUTE) {
      return new SelectedSortingAttributeManager(sortingAttribute, null);
    } else {
      return new SelectedSortingAttributeManager(
        sortingAttribute,
        SORT_ORDER.DESC
      );
    }
  }

  /**
   * Sets the selected sorting order.
   * @param {string} sortingOrder - The new sorting order.
   * @returns {SelectedSortingAttributeManager} A new instance with the updated sorting order.
   */
  setSelectedSortingOrder(
    sortingOrder
  ) {
    return new SelectedSortingAttributeManager(
      this.sortingAttribute,
      sortingOrder
    )
  }
}
